"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PlotlyChart;

var _lodash = require("lodash");

var _react = _interopRequireWildcard(require("react"));

var _useMedia = _interopRequireDefault(require("use-media"));

var _ErrorBoundary = require("../../../components/ErrorBoundary");

var _propTypes = require("../../prop-types");

var _resizeObserver = _interopRequireDefault(require("../../../services/resizeObserver"));

var _visualizationsSettings = require("../../visualizationsSettings");

var _getChartData = _interopRequireDefault(require("../getChartData"));

var _plotly = require("../plotly");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function catchErrors(func, errorHandler) {
  return function () {
    try {
      return func(...arguments);
    } catch (error) {
      // This error happens only when chart width is 20px and looks that
      // it's safe to just ignore it: 1px less or more and chart will get fixed.
      if ((0, _lodash.isString)(error) && (0, _lodash.startsWith)(error, "ax.dtick error")) {
        return;
      }

      errorHandler.handleError(error);
    }
  };
}

function PlotlyChart(_ref) {
  var options = _ref.options,
      data = _ref.data;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      container = _useState2[0],
      setContainer = _useState2[1];

  var errorHandler = (0, _react.useContext)(_ErrorBoundary.ErrorBoundaryContext);
  var isMobile = (0, _useMedia.default)({
    maxWidth: 768
  });
  (0, _react.useEffect)(catchErrors(() => {
    if (container) {
      var plotlyOptions = {
        showLink: false,
        displaylogo: false
      };

      if (_visualizationsSettings.visualizationsSettings.hidePlotlyModeBar) {
        plotlyOptions.displayModeBar = false;
      }

      var chartData = (0, _getChartData.default)(data.rows, options);
      var plotlyData = (0, _plotly.prepareData)(chartData, options);

      var plotlyLayout = _objectSpread({}, (0, _plotly.prepareLayout)(container, options, plotlyData), {
        dragmode: !isMobile ? "zoom" : false
      }); // It will auto-purge previous graph


      _plotly.Plotly.newPlot(container, plotlyData, plotlyLayout, plotlyOptions).then(catchErrors(() => {
        (0, _plotly.applyLayoutFixes)(container, plotlyLayout, options, (e, u) => _plotly.Plotly.relayout(e, u));
      }, errorHandler));

      container.on("plotly_restyle", catchErrors(updates => {
        // This event is triggered if some plotly data/layout has changed.
        // We need to catch only changes of traces visibility to update stacking
        if ((0, _lodash.isArray)(updates) && (0, _lodash.isObject)(updates[0]) && updates[0].visible) {
          (0, _plotly.updateData)(plotlyData, options);

          _plotly.Plotly.relayout(container, plotlyLayout);
        }
      }, errorHandler));
      var unwatch = (0, _resizeObserver.default)(container, catchErrors(() => {
        (0, _plotly.applyLayoutFixes)(container, plotlyLayout, options, (e, u) => _plotly.Plotly.relayout(e, u));
      }, errorHandler));
      return unwatch;
    }
  }, errorHandler), [options, data, container, isMobile]); // Cleanup when component destroyed

  (0, _react.useEffect)(() => {
    if (container) {
      return () => _plotly.Plotly.purge(container);
    }
  }, [container]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "chart-visualization-container",
    ref: setContainer
  });
}

PlotlyChart.propTypes = _propTypes.RendererPropTypes;
//# sourceMappingURL=PlotlyChart.js.map